export enum TradingProcedureType {
    English = 'english',
    Sealed = 'sealed',
    Unknown = 'unknown',
}

export interface TradingProcedureBase {
    id: number;
    type: TradingProcedureType; // доменное значение для логики
    showSellerName: boolean;
    name: string | null;
    sellerOrganizationName: string | null;
    sellerOrganizationLogo: string | null;
    sellerOrganizationTypeName: string | null;
    startDateTime: Date | null;
    endDateTime: Date;
    bidStepAmount: number | null;
    sellerDescription: string | null;
    currency: string;
    createdDateTime: Date;

    lotCount: number;
    contractCount: number;
    debtAmount: number;
    principalAmount: number;
    averageDpd: number;
    minPrice: number;
    currentPrice: number | null;
}

export type DraftTradingProcedure = TradingProcedureBase & {
    status: 'draft';
}

export type PublishedTradingProcedure = TradingProcedureBase & {
    status: 'published';
}

export type ActiveTradingProcedure = TradingProcedureBase & {
    status: 'active';
};

export type AwaitingDecisionTradingProcedure = TradingProcedureBase & {
    status: 'awaitingDecision';
};

export type FinishedTradingProcedure = TradingProcedureBase & {
    status: 'finished';
};

export type CanceledTradingProcedure = TradingProcedureBase & {
    status: 'cancelled';
};

export type TradingProcedure =
    | DraftTradingProcedure
    | PublishedTradingProcedure
    | ActiveTradingProcedure
    | AwaitingDecisionTradingProcedure
    | FinishedTradingProcedure
    | CanceledTradingProcedure;

export interface StatusChangeEvent {
    id: number;
    status: TradingProcedure['status'];
}
